import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { propArrayShape, propShape, } from '../../../../../helpers/custom-prop-types';
import MiddleTaskPartsMiddleColumnComponent from './MiddleTaskPartsMiddleColumnComponent';
const MiddleTaskPartsLargeTaskComponent = (props) => {
    const { largeTask, middleTasks } = props;
    const middles = useMemo(() => middleTasks.filter((middleTask) => middleTask.largeTaskId === largeTask.id), [largeTask, middleTasks]);
    return (_jsxs(_Fragment, { children: [_jsx("dt", { children: largeTask.name }), _jsx("dd", { children: middles.map((middleTask) => (_jsx(MiddleTaskPartsMiddleColumnComponent, { middleTask: middleTask }, middleTask.id))) })] }));
};
MiddleTaskPartsLargeTaskComponent.propTypes = {
    largeTask: propShape().isRequired,
    middleTasks: propArrayShape().isRequired,
};
export default MiddleTaskPartsLargeTaskComponent;
